<template>
    <div>
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 mb-3"
        >
            <div class="title">
                <h1 class="mb-0">PetCare Configurations</h1>
            </div>
        </div>
        <b-card footer-class="p-0" class="side-tab" style="min-height: 500px;">
            <div class="tab-body row">
                <div class="col-md-2 tabs">
                    <div class="nav-scrollable">
                        <div
                            class="text"
                            v-for="title in titles"
                            :key="title.code"
                            :class="{ active: activeTab === title.code }"
                            @click="selectTab(title.code)"
                        >
                            {{ title.label }}
                        </div>
                    </div>
                </div>
                <div id="tab-details" class="col-md-10">
                    <RxRequest
                        v-if="activeTab === 'rx_request'"
                        ref="rx-request"
                    />
                    <PetcareWidget
                        v-if="activeTab === 'petcare_widget'"
                        ref="petcare-widget"
                    />
                    <PetcareOnlineBooking
                        v-if="activeTab === 'petcare_online_booking'"
                        ref="petcare-online-booking"
                    />
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import RxRequest from "@/components/setting-petcare/petcare-rx-request";
import PetcareWidget from "@/components/setting-petcare/petcare-widget";
import PetcareOnlineBooking from "@/components/setting-petcare/petcare-online-booking";

export default {
    components: {
        RxRequest,
        PetcareWidget,
        PetcareOnlineBooking
    },
    data() {
        return {
            isLoading: true,
            scrollTop: 0,
            activeModule: 0,
            titlePositions: [],
            activeTab: "rx_request",
            titles: [
                {
                    code: "rx_request",
                    label: "Rx Request"
                },
                {
                    code: "petcare_widget",
                    label: "PetCare Widget"
                },
                {
                    code: "petcare_online_booking",
                    label: "Online Booking"
                }
            ]
        };
    },
    methods: {
        selectTab(tab) {
            this.activeTab = tab; // Change the active tab when clicked
        }
    }
};
</script>
